import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { useGetDayLimitArrangements } from './hooks/useGetDayLimitArrangements';
import { useGetColumns } from './hooks/useColumns';
import { useTranslation } from 'react-i18next';
import CreateEditForm from './components/CreateEditForm';
import useRemoveDayLimitArrangement from './hooks/useRemoveDayLimitArrangement';
import { DayLimitArrangementsForEmployeeProps } from './types';
import { DayLimitArrangementForEmployeeResponse } from 'generated/index';

export default function DayLimitArrangementsForEmployee({
  employeeId
}: DayLimitArrangementsForEmployeeProps) {
  const { t } = useTranslation('common');
  const { data, isFetching } = useGetDayLimitArrangements(employeeId);
  const columns = useGetColumns({ employeeId });
  const deleteMutation = useRemoveDayLimitArrangement();

  // DataGrid passes an array of selected ids for bulk delete; ensure single id payload
  const onDeleteClick = (ids: string[]) => {
    deleteMutation.mutate({ id: ids[0] });
  };

  return (
    <TableCRUDLayout<DayLimitArrangementForEmployeeResponse>
      FormComponent={(props) => (
        <CreateEditForm {...props} employeeId={employeeId} />
      )}
      rows={data}
      columns={columns}
      loading={isFetching}
      shouldRenderToolBar={false}
      onDeleteClick={onDeleteClick}
      confirmationTitle={t('dayLimitArrangements.confirmationTitle')}
      confirmationBody={t('dayLimitArrangements.confirmationBody')}
      customCreateTitle={t('dayLimitArrangements.createTitle')}
      customEditTitle={t('dayLimitArrangements.editTitle')}
    />
  );
}
